import { API_ENDPOINTS, buildApiUrl } from '../../constants/apiendpoints.constant';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { ProductRow, ProgramBuilderComponentState } from '../../models/program-builder.interface';


@Injectable({
  providedIn: 'root'
})
export class ProgramBuilderService {
  private componentStateSubject = new BehaviorSubject<ProgramBuilderComponentState | null>(null);
  public componentState$ = this.componentStateSubject.asObservable();

  constructor(private http: HttpClient) { }


  ExportProgramBuilderPdf(programBuilderData: any[]): Observable<Blob> {
    const appURL: string = buildApiUrl(API_ENDPOINTS.RESISTANCE_MANAGEMENT.EXPORT_PROGRAM_BUILDER_PDF);
    return this.http.post(appURL, programBuilderData, {
      responseType: 'blob'
    });
  }

  createProduct(selectedProductObj: any, timing: 'PRE' | 'POST'): ProductRow {
    return {
      id: Date.now(),
      product_name: selectedProductObj?.premix_name || '',
      premix_soa: selectedProductObj?.premix_soa || '',
      use_rate: '',
      rate_unit: selectedProductObj?.rate_unit || '',
      active_Ingredients: Array.isArray(selectedProductObj?.active_Ingredients)
        ? selectedProductObj.active_Ingredients.map((ai: any) => ({
          product_name: ai.product_name || '',
          ai_rate: ai.ai_rate || 0,
          solo_concentration: ai.solo_concentration || 0,
          unit: ai.unit || '',
          min_rate: ai.min_rate || '0',
          max_rate: ai.max_rate || '0',
          prodCalculatedData: null,
          aiCalculatedData: null
        }))
        : [],
      timing,
      isNew: true
    };
  }

  getProductOptions(options: string[]): { label: string; value: string }[] {
    return Array.isArray(options)
      ? options.map(val => ({ label: val, value: val }))
      : [];
  }

  // Component state management methods
  saveComponentState(state: ProgramBuilderComponentState): void {
    this.componentStateSubject.next(state);
  }

  getComponentState(): ProgramBuilderComponentState | null {
    return this.componentStateSubject.value;
  }

  clearComponentState(): void {
    this.componentStateSubject.next(null);
  }

}
